export enum BillOfMaterialsTemplateStatus {
  Active = "active",
  Paused = "paused",
}
